
<!--
<button mat-raised-button (click)="isEditable = !isEditable">
  {{!isEditable ? 'Enable edit mode' : 'Disable edit mode'}}
</button>
-->
<div class = "new-quote">

  <h3>Devis</h3>

  <mat-stepper linear #stepper>

    <mat-step [stepControl]="firstFormGroup" [editable]="isEditable">
      <form [formGroup]="firstFormGroup">

        <ng-template matStepLabel>Carte grise</ng-template>

        <!-- <mat-form-field>
        <mat-label>Name</mat-label>
        <input matInput formControlName="firstCtrl" placeholder="Last name, First name" required>
      </mat-form-field>  -->

      <mat-form-field >
        <mat-label>Type de document</mat-label>
        <mat-select formControlName="firstCtrl" name="documentTypes" (selectionChange)="onDocumentTypeChange()" [(value)]="selectedCarDocumentType" required>
          @for (type of carDocumentTypesBD; track type) {
            <mat-option [value]="type">{{type.desc}}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      <div class="car-image">

        <div class = "image-container">

          <img mat-card-image [src]= "(currentDocument != undefined) ? currentDocument : 'assets/images/car_image_holder.png'" alt="Car Image">

        </div>
        <!-- <div class = "image-thumbs">

        <div class="image-thumb"
          *ngFor="let file of carDocumentsFolder  ; index as i"
          [style.border-color]=" (i===currentDocumentIndex) ? 'yellow': 'white'">

          <img mat-card-image
            [src]="(carDocumentsFolder.length! > 0) ? getCarDocument(i) : 'assets/images/car_image_holder.png'" alt="Car Document"
            (click)="selectDocument(i)"
            >
          </div>
        </div>  -->

        <div class="car-pic-upload">
          <label for="files" class="btn"> Ajouter document </label>
          <input id="files" type="file" accept="image/*,.pdf" (change)="selectFiles($event); $event.stopPropagation()" />
        </div>

        @if (selectedFiles.length > 0 && selectedFiles[0] != undefined) {
          <button mat-button class="cta-button"  (click)="convertDocument(selectedCarDocumentType.code, 0)">
            Convertir<mat-icon>upload_file</mat-icon>
          </button>
        }
      </div>
      <h3></h3>
      <div>
        <button class="simple-button" mat-button matStepperNext>Suivant<mat-icon>navigate_next</mat-icon></button>
      </div>
      <h3>Résultat</h3>
      <h6>
        <b> Type:</b> {{ (currentFileData$ | async)!.filename }} <br>
        <b> Contenu: </b>  <pre id="json">{{ toJson((currentFileData$ | async)!.content) }} </pre><br>
      </h6>

    </form>
  </mat-step>

  <mat-step [stepControl]="secondFormGroup" [editable]="isEditable">
    <form [formGroup]="secondFormGroup">

      <ng-template matStepLabel>Fill out your address</ng-template>

      <mat-form-field>
        <mat-label>Address</mat-label>
        <input matInput formControlName="secondCtrl" placeholder="Ex. 1 Main St, New York, NY"
          required>
        </mat-form-field>

        <div>
          <button mat-button matStepperPrevious>Précédent<mat-icon>navigate_before</mat-icon></button>
          <button mat-button matStepperNext>Suivant<mat-icon>navigate_next</mat-icon></button>
        </div>

      </form>
    </mat-step>

    <mat-step>
      <ng-template matStepLabel>Done</ng-template>

      <p>You are now done.</p>

      <div>
        <button mat-button matStepperPrevious>Précédent<mat-icon>navigate_before</mat-icon></button>
        <button mat-button (click)="stepper.reset()">Annuler</button>
      </div>
    </mat-step>

  </mat-stepper>

</div>